import { Component, Injectable, OnInit, Input, Compiler } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { NgbActiveModal, ModalDismissReasons, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { AuthenticationService } from '../../../../../app/services/authentication.service';
import { AlertService } from '../../../../../app/utils/alert.service';
import { Router, NavigationEnd } from "@angular/router";
import { BindComponentService } from "../../../../../app/utils/bind.component.service";
import { PackageHireModalComponent } from '../../../../../app/home/paraEmpresas/consume/welcome/packageHire/content.component';

/**
 * this.author Wesley Mascarenhas
 * @version $Id: content.component.ts 62312 2017-09-12 17:39:13Z bernardo.d.siqueira $
 */
@Component({
  selector: 'welcomeModal',
  templateUrl: './content.modal.template.html'
})
@Injectable()
export class WelComeComponent implements OnInit {


  @Input() textNewService: string;
  @Input() isHibrid: boolean;
  @Input() isLogin: boolean;
  @Input() textWelcome: string;

  public textHibrid: string;
  public hasPackageHireFlag: any;
  

  constructor(private activeModal: NgbActiveModal,
     private authService: AuthenticationService, 
     private alertService: AlertService,
     private router: Router,
     private bindComponent: BindComponentService, 
     private modalService: NgbModal) {
  }

  ngOnInit() {
    document.getElementsByClassName("modal-dialog")[0] && document.getElementsByClassName("modal-dialog")[0].classList.add("modal-welcome");
  };

  private close() {
    this.activeModal.dismiss();
    /*Pedido 407598: Nâo exibir mais o segundo popup*/
   
  }

  public redirect(andress:string){
    this.router.navigate([andress], { queryParams: {setps:true} });
    this.close();
  }
}


// WEBPACK FOOTER //
// ./src/app/home/paraEmpresas/consume/welcome/content.component.ts